export default __webpack_public_path__ + "dd790d78e7f9e8c4327cccdc3dcc61e5.png";